const utilArrSpliceIn = (array, idx, val, canEdit) => {
  const newLen = array.length + 1
  if (canEdit && idx + 1 === newLen) {
    array[idx] = val
    return array
  }
  const newArray = new Array(newLen)
  let after = 0
  for (let ii = 0; ii < newLen; ii++) {
    if (ii === idx) {
      newArray[ii] = val
      after = -1
    } else {
      newArray[ii] = array[ii + after]
    }
  }
  return newArray
}

const utilArrSpliceOut = (array, idx, canEdit) => {
  const newLen = array.length - 1
  if (canEdit && idx === newLen) {
    array.pop()
    return array
  }
  const newArray = new Array(newLen)
  let after = 0
  for (let ii = 0; ii < newLen; ii++) {
    if (ii === idx) {
      after = 1
    }
    newArray[ii] = array[ii + after]
  }
  return newArray
}

// http://jsperf.com/copy-array-inline
const utilArrCopy = (arr, offset) => {
  offset = offset || 0
  const len = Math.max(0, arr.length - offset)
  const newArr = new Array(len)
  for (let ii = 0; ii < len; ii++) {
    // @ts-expect-error We may want to guard for undefined
    // values with `if (arr[ii + offset] !== undefined`,
    // but ths should not happen by design
    newArr[ii] = arr[ii + offset]
  }
  return newArr
}

const utilArrSetAt = (array, idx, val, canEdit) => {
  const newArray = canEdit ? array : utilArrCopy(array)
  newArray[idx] = val
  return newArray
}

const utilFlagSpread = fn => ((fn.unspread = true), fn)

const utilInvariant = (condition, error) => {
  if (!condition) throw new Error(error)
}

const utilAssertNotInfinite = size => {
  utilInvariant(
    size !== Infinity,
    'Cannot perform this action with an infinite size.'
  )
}

const utilAssertTuple = tuple => {
  if (!Array.isArray(tuple))
    throw new Error(`Expected [K, V] tuple: ${tuple}`)

  return true
}

const utilHasOwnProperty = Object.prototype.hasOwnProperty

export {
  utilFlagSpread,
  utilHasOwnProperty,
  utilArrSpliceIn,
  utilArrSpliceOut,
  utilArrCopy,
  utilArrSetAt,
  utilInvariant,
  utilAssertTuple,
  utilAssertNotInfinite
}
